import moment from 'moment';

export function formatarTamanhoBytes(bytes: number): string {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = 2;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export function formatarDataHora(dataHora: string | Date | null | undefined): string {
  if (!dataHora) return "-";
  return moment(dataHora).format("DD/MM/YYYY [às] HH:mm");
}

export function formatarDataSomente(dataHora: string | Date | null | undefined): string {
  if (!dataHora) return "-";
  return moment(dataHora).format("DD/MM/YYYY");
}
